/**
 * Single source of truth for company identity information.
 *
 * Every component, metadata record and JSON-LD generator must consume these
 * values instead of hard-coding them. Never duplicate them elsewhere.
 */
export const company = {
  name: "Schmeitz De Groen AI Labs",
  kvk: "98988328",
  email: "info@schmeitzdegroenailabs.com",
  phoneNumbers: [
    { display: "+31 6 3755 7073", href: "tel:+31637557073" },
    { display: "+31 6 1283 1732", href: "tel:+31612831732" },
  ],
  /**
   * Business location (confirmed). City-level until a street address is
   * deliberately published — add street/houseNumber here if that changes.
   */
  displayLocation: {
    city: "Maastricht",
    region: "Limburg",
    country: "Nederland",
    countryEn: "The Netherlands",
  },
  socialProfiles: {
    linkedin: "https://www.linkedin.com/company/schmeitz-de-groen-ai-labs",
    instagram: "https://www.instagram.com/schmeitz_de_groen_ai_labs",
    facebook: "https://www.facebook.com/profile.php?id=61586179322431",
  },
  founders: [
    {
      id: "rutger-de-groen",
      name: "Rutger de Groen",
      role: { nl: "Medeoprichter", en: "Co-Founder" },
    },
    {
      id: "camiel-schmeitz",
      name: "Camiel Schmeitz",
      role: { nl: "Medeoprichter", en: "Co-Founder" },
    },
  ],
  logo: "/SCHMEITZ_DE_GROEN.svg",
} as const

export function formatDisplayLocation(locale: "nl" | "en"): string {
  const { city, country, countryEn } = company.displayLocation
  return `${city}, ${locale === "nl" ? country : countryEn}`
}
